import * as angular from 'angular';
import * as _ from "lodash";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsEnums } from "../../shared/dto/aps.enums";
import NotificationHubName, { NotificationHub, NotificationHubService } from "../../services/notifications/notification.hub";
import NotificationsName, { Notifications } from "../../models/notifications/notifications";
import NavigationModelName, { NavigationModel, Plant } from "../../models/navigation";
import NotificationServiceName, { NotificationService } from "../../services/notifications/notification.service";
import EnvironmentName, { Environment } from "../../shared/config/environment";
import AuthServiceName, { AuthService } from "../../services/auth/auth.service";
import AuthDataServiceName, { AuthDataService, RoleLocation } from "../../services/auth/authData.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import DowntimeServiceName, { DowntimeService } from "../../services/downtimes/downtime.service";
import CheckListInstancesServiceName, { CheckListInstancesService } from "../../services/checkLists/checkListInstances.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import UserProfileName, { UserProfile } from "../../models/userProfile";
import StateRolesServiceName, { StateRolesService } from "../../services/stateRoles/stateRoles.service";
import { StateParams } from "../../common";
import { States } from "../../shared/config/constant.module";
import UserProfileControllerName, { openUserProfile } from "../../controllers/userProfile/userProfile.controller";
import BlockedSignOffControllerName, { openBlockedSignOff } from "./blockedSignOff.controller";
import OpenReleaseNotesCtrollerName, { openReleaseNotes } from "./openReleaseNotes.controller";

let requires = [
  'ui.router',
  NotificationHubName,
  NotificationsName,
  NavigationModelName,
  NotificationServiceName,
  EnvironmentName,
  AuthServiceName,
  AuthDataServiceName,
  NavigationServiceName,
  DowntimeServiceName,
  CheckListInstancesServiceName,
  LoaderServiceName,
  UserProfileName,
  StateRolesServiceName,
  UserProfileControllerName,
  BlockedSignOffControllerName,
  OpenReleaseNotesCtrollerName
];

export interface MenuItem {
  text: string;
  state: any;
}

export interface Menu {
  userIsPermitted: boolean;
  menuItems: MenuItem[];

  toggleMenu: (event: MouseEvent) => void;
  goTo: (menuItem: MenuItem) => void;
}

export interface HeaderController {
  notificationsHub: NotificationHub;
  changeRole: () => void;
  notifications: Notifications;
  navigation: NavigationModel;
  showSelectPlant: boolean;
  userData: apsViewModels.UserData;
  roleName: string;
  showAdminMenu: boolean;
  adminMenu: Menu;
  showReportMenu: boolean;
  reportMenu: Menu;
  showMachineMenu: boolean;
  machineMenu: Menu;
  plants: Plant[];
  releaseNoteNotification: any;

  signOff: () => void;
  switchPlantShop: (plantChanged?: boolean) => void;
  toggleSelectPlant: (event: MouseEvent) => void;
  selectPlant: (plant: Plant) => void;
  selectShop: (shop: apsViewModels.ShopNavigation) => void;
  showProfileEditor: () => void;
  showReleaseNotes: () => void;
  environmentName: string;
  environmentHighlight: string;
  environmentVersion: string;
}

export default angular.module('aps.controller.header', requires)
  .controller('HeaderCtrl', headerCtrl)
  .name;

function headerCtrl(
  $state: angular.ui.IStateService,
  notificationHub: NotificationHubService,
  notificationService: NotificationService,
  environment: Environment,
  authService: AuthService,
  authDataService: AuthDataService,
  navigationService: NavigationService,
  downtimeService: DowntimeService,
  checkListInstancesService: CheckListInstancesService,
  loaderService: LoaderService,
  userProfile: UserProfile,
  stateRolesService: StateRolesService,
  $q: angular.IQService,
  $stateParams: StateParams,
  $window: angular.IWindowService,
  $scope: angular.IScope,
  $timeout: angular.ITimeoutService,
  $modal: mm.foundation.modal) {
  'use strict';

  var vm = <HeaderController>this;

  vm.environmentVersion = environment.VERSION;
  vm.environmentName = environment.NAME;
  vm.environmentHighlight = environment.HIGHLIGHT;
  vm.plants = [];
  vm.releaseNoteNotification;

  var getShopId = (selectedRoleLocation?: RoleLocation) => {
    selectedRoleLocation = selectedRoleLocation || authDataService.getSelectedRoleLocation();
    return selectedRoleLocation.role.roleRequiresShops && selectedRoleLocation.shop ?
      selectedRoleLocation.shop.id :
      $stateParams.shopId;
  };

  var loadNavigation = (selectedRoleLocation?: RoleLocation) => {
    return navigationService.getNavigation()
      .then((navigation) => {
        vm.plants = navigation.plants().filter(x => !x.isDisabled);
        if (!navigation.selectedPlant) {
          _.forEach(navigation.plants(), (plant) => {
            var shop = _.find(plant.shops, { id: getShopId(selectedRoleLocation) });
            if (shop) {
              navigation.selectedPlant = plant;
              navigation.selectedShop = shop;
            }
          });
        }
        vm.navigation = navigation;
        return navigation;
      });
  };

  var initializeNotifications = function () {
    var selectedRoleLocation = authDataService.getSelectedRoleLocation();
    loadNavigation(selectedRoleLocation).then(() => {
      var shopId = vm.navigation.selectedShop.id;
      var role = selectedRoleLocation.role;
      notificationService
        .getNotifications(shopId, role.roleId, vm.userData.shift, $window, $scope)
        .then((notifications) => {
          vm.notifications   = notifications;

          //Get Release Notes
          notificationService.getReleaseNotesNotification().then((releaseNotes) => {
            vm.releaseNoteNotification = releaseNotes;
          })       

          vm.notificationsHub = notificationHub.createNotificationHub(
            shopId,
            role.roleId,
            vm.userData.shift,
            () => vm.notifications);
          vm.navigation.initialize(vm.notificationsHub, vm.userData);
        });
    });
  };

  $scope.$on('$destroy', () => {
    if (this.notificationsHub) {
      this.notificationsHub.stop();
    }
  });

  var performSignOff = () => {
    authService.logoff(vm.navigation);
    userProfile.update(null);
    $state.go(States.SIGN_IN);
  };

  var userId = authDataService.getUserId();
  vm.signOff = function () {
    var selectedRoleLocation = authDataService.getSelectedRoleLocation();
    var role = selectedRoleLocation.role;
    var isOperator = selectedRoleLocation.hasFlag(apsEnums.RoleFlags.Operator);
    var isHotEnd = isOperator && role.roleLocation === apsEnums.Location.HotEnd;

    var openDowntimes: apsViewModels.DowntimeActivity[] = [];
    var blockingChecklists: apsViewModels.CheckListInstanceListItem[] = [];
    var signOffBlockingPromises = [];

    if (isHotEnd) {
      signOffBlockingPromises.push(downtimeService.getOpenDowntimes($stateParams.shopId).
        then((retOpenDowntimes) => {
          openDowntimes = retOpenDowntimes;
        }));
    }

    if ($stateParams.plantId && $stateParams.shopId) {
      signOffBlockingPromises.push(checkListInstancesService.getByRole($stateParams.plantId,
        $stateParams.shopId,
        role.roleId,
        apsEnums.CheckListView.Blocking, false).
        then((checkLists) => {
          blockingChecklists = checkLists;
        })
      );
    }

    loaderService.loadingPromise($q.all(signOffBlockingPromises).then(() => {
      if ((openDowntimes && openDowntimes.length)
        || (blockingChecklists && blockingChecklists.length)) {
        showBlockingLogoffDialog(openDowntimes, blockingChecklists);
      } else {
        performSignOff();
      }
    }));
  };

  vm.switchPlantShop = () => {
    $state.go($state.current.name, {
      plantId: vm.navigation.selectedPlant.id,
      shopId: vm.navigation.selectedShop.id,
      userId: userId
    });
  };

  vm.showSelectPlant = false;
  vm.toggleSelectPlant = (event: MouseEvent) => {
    if (vm.navigation.plants().length > 1) {
      vm.showSelectPlant = !vm.showSelectPlant;
    }
    vm.showAdminMenu = false;
    vm.showReportMenu = false;
    vm.showMachineMenu = false;
    event.stopPropagation();
  };

  angular.element($window).click(() => {
    if (vm.showSelectPlant || vm.showAdminMenu || vm.showReportMenu || vm.showMachineMenu) {
      $timeout(() => {
        vm.showSelectPlant = false;
        vm.showAdminMenu = false;
        vm.showReportMenu = false;
        vm.showMachineMenu = false;
      });
    }
  });

  vm.selectPlant = (plant: Plant) => {
    vm.showSelectPlant = false;
    if (vm.navigation.selectPlant(plant)) {
      vm.switchPlantShop();
    }
  };

  vm.selectShop = (shop: apsViewModels.ShopNavigation) => {
    if (vm.navigation.selectPlantShop(vm.navigation.selectedPlant, shop)) {
      vm.switchPlantShop();
    }
  };

  var initializeUserProfileSection = function () {
    var selectedRoleLocation = authDataService.getSelectedRoleLocation();
    if (selectedRoleLocation) {
      if (selectedRoleLocation.role) {
        vm.roleName = selectedRoleLocation.role.roleName;
      }
    }
  };

  vm.showAdminMenu = false;
  var initializeAdminMenu = function () {

    vm.adminMenu = {
      userIsPermitted: authDataService.isPlantOrAPSIOAdmin(),
      toggleMenu: function (event: MouseEvent) {
        vm.showReportMenu = false;
        vm.showAdminMenu = !vm.showAdminMenu;
        vm.showSelectPlant = false;
        vm.showMachineMenu = false;
        event.stopPropagation();
      },
      goTo: function (menuItem) {
        $state.go(menuItem.state);
      },
      menuItems: []
    };

    var menuItems =
      [{ text: 'Alert Roles', state: States.ALERTROLES },
      { text: 'Defect Types', state: States.DEFECT_TYPES },
      { text: 'Defect Types Mappings', state: States.VIEW_MACHINE_DEFECT_MAPPINGS },
      { text: 'Holidays', state: States.HOLIDAYS },
      { text: 'Jobs', state: States.JOBS },
      { text: 'Job Runs', state: States.JOB_RUNS },
      { text: 'Equipment', state: States.EQUIPMENT },
      { text: 'Formulas', state: States.FORMULAS },
      { text: 'Plants', state: States.PLANTS },
      { text: 'Plant Feature Settings', state: States.PLANT_FEATURE_SETTINGS },
      { text: 'Shops', state: States.SHOPS },
      { text: 'Users', state: States.USERS },
      // { text: 'Tiama Defects', state: States.VIEW_TIAMA_DEFECT_MAPPINGS },
      { text: 'Check Lists', state: States.CHECKLISTS },
      { text: 'Send Notifications', state: States.GLOBAL_NOTIFICATIONS },
      { text: 'Section Changes', state: States.SECTION_CHANGES },
      { text: 'Line Configuration', state: States.LINE_CONFIG },
      // { text: 'Check Detector Defect Mapping', state: States.CHECK_DETECTOR_DEFECT_MAPPING },
      { text: 'Palletizers', state: States.PALLETIZERS },
      { text: 'Line Equipment Types', state: States.LINE_EQUIPMENT_NAMES }
      ];


    vm.adminMenu.menuItems = _.filter(menuItems, function (item) {
      return stateRolesService.stateRoleRequirementsSatisfiedForStateName(item.state);
    });


    if (authDataService.isAuthorizedForBatchSummary()) {
      vm.adminMenu.menuItems.splice(1, 0,
        //{ text: 'Batch Formulas', state: States.BATCH_FORMULAS },
        //{ text: 'Batch Formula Usages', state: States.BATCH_FORMULA_USAGES },
        { text: 'Commodities', state: States.COMMODITIES },
        { text: 'Commodity Bin Mapping', state: States.COMMODITY_BIN },
        //{ text: 'Batch Summary V1', state: States.BATCH_SUMMARY },
        { text: 'Batch Summary', state: States.BATCH_SUMMARY },
      );
    }
  };

  vm.showReportMenu = false;
  var initializeReportMenu = function () {

    vm.reportMenu = {
      userIsPermitted: true,
      toggleMenu: function (event: MouseEvent) {
        vm.showAdminMenu = false;
        vm.showReportMenu = !vm.showReportMenu;
        vm.showSelectPlant = false;
        vm.showMachineMenu = false;
        event.stopPropagation();
      },
      goTo: function (menuItem) {
        $state.go(menuItem.state);
      },
      menuItems: []
    };

    var menuItems = [
      { text: 'Batch Formula Usage', state: States.BATCH_FORMULA_USAGE_REPORT },
      { text: 'Chat and Comments', state: States.CHAT_REPORT },
      { text: 'Check List', state: States.CHECKLIST_REPORT },
      { text: 'Check List Hourly', state: States.HOURLY_CHECKLIST_REPORT },
      { text: 'Critical Defects', state: States.CRITICAL_DEFECT_REPORT },
      { text: 'Defects', state: States.DEFECTS_REPORT },
      { text: 'Downtime V2', state: States.DOWNTIME_REPORT_V2 },
      { text: 'Defect Types', state: States.VIEW_DEFECT_TYPES },
      { text: 'Deleted Defects', state: States.DELETED_DEFECT_REPORT },
      { text: 'Deleted Gob Weights', state: States.DELETED_GOB_WEIGHT_REPORT },
      { text: 'Downtime', state: States.DOWNTIME_REPORT },
      { text: 'Furnace Pull', state: States.FURNACE_PULL_REPORT },
      { text: 'Job Runs', state: States.JOB_RUN_REPORT },
      { text: 'Production Summary', state: States.COUNT_SUMMARY },
      { text: 'Tank Metrics', state: States.TANK_METRICS_REPORT },
      { text: 'Tool Change', state: States.TOOL_CHANGE_REPORT },
      { text: 'Tool Change History', state: States.TOOLCHANGE_HISTORY_REPORT},
      { text: 'Top Defects', state: States.TOP_DEFECTS_REPORT },
      { text: 'Qualifications', state: States.QUALIFICATIONS_REPORT },
      { text: 'Reject Rate', state: States.REJECT_RATE_REPORT },
      { text: 'Shift Detail', state: States.SHIFT_DETAIL_REPORT },
      { text: 'Shop Count Summary', state: States.SHOP_COUNT_SUMMARY_V2 },
      { text: 'Shop Cavity Efficiency', state: States.CAVITY_EFFICIENCY },
      { text: 'Shop Cavity Correlation', state: States.CAVITY_CORRELATION },
      { text: 'LPA Scorecard Report', state: States.SCORECARD },
      { text: 'Data Point History', state: States.COUNTS_DATA_POINT_HISTORY },
      { text: 'Downtime Shift Report', state: States.DOWNTIME_SHIFT_REPORT},
      { text: 'Downtime Shift Report Insight', state: States.DOWNTIME_SHIFT_REPORT_INSIGHT},
      { text: 'Dump Gate Time Report', state: States.DUMPGATETIME_REPORT},
    ];

    // Temporary - only add the Production Shift Report if the user has that role (while it's under construction)
    if (authDataService.isProductionShiftReport()) {
      // menuItems.push( { text: 'Production Shift Report', state: States.PRODUCTION_SHIFT_REPORT} );
      menuItems.push({ text: 'Production Shift Report v2', state: States.PRODUCTION_SHIFT_REPORTV2 });
    }

    //Temporarily keep Held Ware report to Elmira
    //if ($stateParams.plantId == 'bbdf0000-3a00-000d-724d-08d2e5fa8e34' || $stateParams.plantId == 'bbdf0000-3a00-000d-9874-08d2e5fa8e0e' ){
    menuItems.push({ text: 'Held Ware', state: States.WARE_HELD_REPORT });
    //}
    //Temporary- only add the Weekly KPI Report if the user has Production Shift Report role
    if (authDataService.isProductionShiftReport()) {
      menuItems.push({ text: 'Weekly KPIs', state: States.WEEKLY_KPI_REPORT });
    }
    if (authDataService.isKpiAudit()) {
      menuItems.push({ text: 'Edit Production Report Records', state: States.PALLETKPI });
    }
    if (authDataService.isHotEndBonusReport()) {
      menuItems.push({ text: 'Hot End Bonus Report', state: States.HOTENDBONUS_REPORT_V2 });
    }
    vm.reportMenu.menuItems = _.filter(menuItems, function (item) {
      return stateRolesService.stateRoleRequirementsSatisfiedForStateName(item.state);
    });
  };

  vm.showMachineMenu = false;
  var initializeMachineMenu = function () {

    vm.machineMenu = {
      userIsPermitted: authDataService.isPlantOrAPSIOAdmin(),
      toggleMenu: function (event: MouseEvent) {
        vm.showAdminMenu = false;
        vm.showReportMenu = false;
        vm.showSelectPlant = false;
        vm.showMachineMenu = !vm.showMachineMenu;
        event.stopPropagation();
      },
      goTo: function (menuItem) {
        $state.go(menuItem.state);
      },
      menuItems: []
    };

    var menuItems = [
      { text: 'FlexIS Details', state: States.FLEX_IS_DETAILS },
    ];

    vm.machineMenu.menuItems = _.filter(menuItems, function (item) {
      return stateRolesService.stateRoleRequirementsSatisfiedForStateName(item.state);
    });
  };

  vm.showProfileEditor = function () {
    openUserProfile($modal);
  };

  vm.changeRole = () => {
    if (authDataService.getRoles().length > 1) {
      $state.go(States.SELECT_ROLE, { userId: userId });
    } else {
      vm.showProfileEditor();
    }
  };

  vm.showReleaseNotes = () => {
    openReleaseNotes($modal, this.releaseNoteNotification); 
  }

  authService.getUserData().then(userData => {
    vm.userData = userData;
    initializeNotifications();
    initializeUserProfileSection();
    initializeAdminMenu();
    initializeReportMenu();
    initializeMachineMenu();
  });

  function showBlockingLogoffDialog(
    openDowntimes: apsViewModels.DowntimeActivity[],
    blockingChecklists: apsViewModels.CheckListInstanceListItem[]
  ) {
    openBlockedSignOff({
      openDowntimes: openDowntimes,
      blockingChecklists: blockingChecklists,
      shopId: vm.navigation.selectedShop.id,
      signOff: performSignOff
    }, $modal);
  }
}


// WEBPACK FOOTER //
// ./src/app/layout/header/header.controller.ts